module.exports = __webpack_public_path__ + "img/bg_awaiting.c2b9a183.png";